module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"teachers_class_copy_class_url","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"classroomID":{"type":"string","pattern":"^[a-z0-9]{24}$"},"url":{"type":"string","format":"url"}},"required":["user","classroomID","url"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/teachers_class_copy_class_url.json
// module id = 597
// module chunks = 97